import { CircularLoader, Typography, Icon } from '@sanlam-glacier/app-common/components';
import { PropsWithChildren } from 'react';
import styles from './profile-expanding-menu.module.scss';
import topBarStyles from '../../TopBar.module.scss';
import clsx from 'clsx';

interface ProfileExpandingMenuProps {
  isOpen: boolean;
  isLoading: boolean;
  onExpandClick: () => void;
}

export const ProfileExpandingMenu = ({
  isOpen,
  isLoading,
  onExpandClick,
  children
}: PropsWithChildren<ProfileExpandingMenuProps>) => {
  return (
    <div className={topBarStyles.contextMenuExtraSidePadding}>
      <div
        className={clsx(topBarStyles.switchProfileToggle, topBarStyles.contextMenuBaseSidePadding)}
        onClick={() => onExpandClick()}
      >
        {isLoading ? (
          <div className={styles.profileExpandingMenuLoader}>
            <CircularLoader />
          </div>
        ) : (
          <>
            <Typography variant={Typography.VARIANT.O1} color={Typography.COLOR.INHERIT}>
              SWITCH PROFILE
            </Typography>
            <div>
              {isOpen ? (
                <Icon icon='navigation_expand-less' className={topBarStyles.xLargeIcon} />
              ) : (
                <Icon icon='navigation_expand-more' className={topBarStyles.xLargeIcon} />
              )}
            </div>
          </>
        )}
      </div>
      <div>{isOpen && !isLoading ? children : null}</div>
    </div>
  );
};
